import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=ca58f626&scoped=true&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"
import style0 from "./initial.vue?vue&type=style&index=0&id=ca58f626&prod&lang=scss&"
import style1 from "./initial.vue?vue&type=style&index=1&id=ca58f626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca58f626",
  null
  
)

export default component.exports